<template>
  <div class="oreder-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('bill.pay.title')"
      :visible="visible"
      width="728px"
      :before-close="handleClose"
    >
      <div class="oreder-modal-wrap">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1">
            <p slot="title" class="title">{{$t('bill.pay.detail')}}</p>
            <div class="summarybox">
              <div class="summary-head">
                <p>{{$t('bill.pay.tNumber')}} {{ order.sn }}</p>
              </div>
              <div class="summary-wrap">
                <dl>
                  <dt></dt>
                  <dd>
                    <p v-html="$t('bill.pay.zone') + showZone(order.zone)"></p>
                  </dd>
                  <dd>
                    <p>{{$t('bill.pay.oType')}} {{ order.type }}</p>
                  </dd>
                </dl>
                <dl>
                  <dt></dt>
                  <dd>
                    <p>{{$t('bill.pay.pType')}} {{ order.product_name }}</p>
                  </dd>
                  <dd>
                    <p>{{$t('bill.pay.time')}} {{ order.create_time }}</p>
                  </dd>
                </dl>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-form  label-position="top">
          <el-form-item>
            <PaymentMethod ref="selectpay" @setPayCode="setPayCodes" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="modal-footer-left">
          <span>{{$t('bill.pay.price')}}</span>
          <span class="price">$ {{ order.pay_amount }}</span>
        </div>
        <el-button @click="visible = false">{{$t('bill.pay.cancel')}}</el-button>
        <el-button type="primary" @click="pay" :loading="requestPending">{{$t('bill.pay.pay')}}</el-button>
      </div>
    </el-dialog>
    <!-- 支付状态弹窗 -->
    <Paying ref="paymodal" @close="payClose"/>
  </div>
</template>
<script>
  import PaymentMethod from "../paySelect/PaymentMethod";
  import Paying from "../payDialog/Paying";
  export default {
    inject:['reload'],
    data() {
      return {
        activeName: '1',
        selectedCard: 1,
        payCode: '',
        callPayApiMethod: '',
        cardId: '',
        visible: false,
        cardPopover: false, //卡列表选择
        order: {},
        requestPending: false,
        // paymentMethod: 'balance',
        extend: {
          password: ''
        }
      };
    },
    computed: {
      upperCase: function () {
        if(this.payCode != '') {
          return this.payCode.substring(0, 1).toUpperCase() + this.payCode.substring(1);
        } else {
          return this.payCode;
        }
      }
    },
    watch: {
      visible: {
        handler(n, o) {
          this.visible = n;
          let self = this;
          if(this.visible){
            this.$nextTick(function () {
              self.$refs.selectpay.amount = self.order.pay_amount;
            })
          }
        },
      },
    },
    components: {
      PaymentMethod,
      Paying,
    },
    props: {},
    created() {

    },
    methods: {
      showZone(zone) {
        return zone;
      },
      payClose(){
        window.clearInterval(this.refreshIntervalId);
        this.visible = false;
      },

      number(e){
        let flag = new RegExp('^[1-9]([0-9])*$').test(e.target.value);
        if(!flag) {
          this.amount = '';
        }
      },
      handleClose() {
        this.visible = false;
        window.clearInterval(this.refreshIntervalId);
      },
      showChange() {
        this.visible = !this.visible;
      },
      // 支付
      async pay() {
        this.payCode = this.$refs.selectpay.payCode;
        this.callPayApiMethod = this.$refs.selectpay.callPayApiMethod;
        this.extend.password = this.$refs.selectpay.extend.password;
        if (this.payCode === 'balance' && !this.extend.password) {
          this.$message.error('Please enter the login password')
          return false
        }
        if(this.payCode == '') {
          this.$message.error('Please select payment method!');
          this.requestPending = false
          return false
        }
        this.$refs.selectpay.orderSn = this.order.sn;
        this.$refs.paymodal.orderType = 'orders';
        this.$refs.paymodal.orderSn = this.order.sn;
        if (this.callPayApiMethod == 'page') {
          this.$nextTick(() => {
            this.$refs.paymodal.showChange();
            document.getElementById(this.$refs.selectpay.form_id).submit();
          });
          this.requestPending = false
        } else {
          let {data: {code, message, data}} = await this.$api.Payment({
            sn: this.order.sn,
            pay_code: this.payCode,
            order_code: "Orders",
            platform: "pc",
            extend: this.extend,
          });
          if (code !== 0) {
            this.$message.error(message)
            this.requestPending = false
            return false
          }
          this.$message.success(message);
          this.visible = false;
        }
      },
      setPayCodes(payCode, cardId, callPayApiMethod) {
        this.payCode = payCode;
        this.callPayApiMethod = callPayApiMethod;
      },
    },
  };
</script>

<style scoped lang="scss">
  .purchase-type {
    display: flex;
    align-items: center;
    padding-bottom: 16px;

    p {
      color: #0f1e33;
      font-size: 14px;
      line-height: 22px;
      width: 150px;
      opacity: 0.8;
      flex-shrink: 0;
    }

    ul {
      flex: 1;
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(3, 160px);

      li {
        width: 160px;
        height: 90px;
        border: 1px solid #dbe1e8;
        cursor: pointer;

        .iconbox {
          display: flex;
          margin: 0 auto 12px;
          padding: 24px 20px 0;
          p {
            flex: 1;
            height: 16px;
            .icon {
              height: 16px;
              width: 100%;
              font-size: 30px;
            }
          }
        }
        .payicon-list {
          padding: 0 24px;
        }

        p {
          color: #0f1e33;
          font-size: 14px;
          text-align: center;
          font-weight: bold;
        }

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
        }

        &.pay-active {
          border-color: #3377ff;
          box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
        }
      }
    }
  }
  .tips {
    font-size: 12px;
    margin-bottom: 24px;
  }
  .payment-list {
    max-height: 400px;
    overflow: auto;
    .payment-item {
      font-size: 16px;
      border: 1px solid #dbe1e8;
      padding: 10px 24px;
      margin-bottom: 12px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .imgbox {
        width: 60px;
        height: 30px;
        text-align: center;
        margin-right: 20px;
        .icon {
          display: inline-block;
          width: 60px;
          height: 30px;
        }
      }

      .payment-card {
        height: 50px;
        display: flex;
        align-items: center;
        li {
          color: #0f1e33;
          font-size: 14px;
          margin-right: 20px;
          &:first-child {
            width: 90px;
          }
        }
        .orange {
          color: #f7ba2a;
        }
      }
    }
    .active-payment {
      border-color: #3377ff;
      box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
    }
    .payment-item:hover {
      box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
    }
  }
  .addBtn {
    margin-left: 150px;
    margin-bottom: 24px;
  }
  .password-wrap {
    padding-left: 150px;
    position: relative;
    > p {
      position: absolute;
      left: 0;
      line-height: 40px;
    }
  }
  .view-icon {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    font-size: 16px;
    cursor: pointer;
    padding-right: 10px;
  }
</style>
<style scoped lang="scss">
  .summarybox {
    width: 100%;
    background: #ffffff;
    border: 1px solid #dbe1e8;

    .summary-head {
      padding: 16px 24px;
      border-bottom: #e1e2e6;
      border-bottom: 1px solid #e1e2e6;

      p {
        color: #0f1e33;
        margin-right: 20px;
      }
    }

    .summary-wrap {
      padding: 24px 40px;
      display: flex;
      justify-content: space-between;

      dl {
        width: 48%;
        flex-shrink: 0;

        dt {
          font-size: 14px;
          color: #0F1E33;
          line-height: 14px;
        }

        dd {
          display: flex;
          margin-top: 16px;
          line-height: 32px;

          p {
            flex: 1;
            flex-shrink: 0;
            line-height: 32px;
            color: #0F1E33;
          }
        }
      }
    }
  }
</style>
<style>
  .oreder-modal-wrap .el-select {
    display: block;
  }
  .oreder-modal-wrap .el-collapse {
    border: none;
    margin-bottom: 32px;
  }
  .card-details .el-input__inner {
    height: 56px;
  }
  .oreder-modal-wrap .el-collapse-item__header {
    border: 1px solid #dbe1e8;
    color: #0f1e33;
    font-size: 14px;
    padding-left: 16px;
  }
  .oreder-modal-wrap .el-collapse-item__header.is-active {
    box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.1);
  }

  .oreder-modal-wrap .el-collapse-item__content {
    padding-bottom: 0;
    background: #dbe1e8;
  }
  .oreder-modal-wrap .el-form-item__label {
    color: #5e6d81;
    font-size: 12px;
  }
</style>




// WEBPACK FOOTER //
// src/components/user/PayOrder.vue